import React, { useEffect, useRef, useState } from 'react'
import QRCode from 'react-qr-code';
import * as htmlToImage from "html-to-image";
import { useNavigate, useParams } from 'react-router-dom';


import axios from "../axiosInstance";
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import { Button, Modal } from 'react-bootstrap';
import { errorMessage } from '../hooks/UserLogs';
export default function AgencyDetails() {
  const [Agency, setAgency] = useState({});
  const [profile, setProfile] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [ListAgencies, setListAgencies] = useState([]);
  const [idAgency, setIdAgency] = useState("");
  const [percent, setPercent] = useState(0);
  const [showPercenChange, setShowPercenChange] = useState(false)

  const qrCodeRef = useRef(null);
  const inputFile = useRef(null);
  const { id } = useParams();
  const bUrl = process.env.REACT_APP_B_URL;
  const navigate = useNavigate();

  let header =
  {
    'Content-Type': 'application/json'
  };

  const handleCloseUpdate = () => {
    setPercent(0);
    setShowPercenChange(false);
  }

  const upadatePercent = () => {

    let percentValue = percent / 100;
    axios.post(bUrl + "/agencies/define-percentage-purchase",

      //birthDay: birthDay,
      {
        "idStaff": sessionStorage.getItem('idUser'),
        "idAgency": id,
        "percentage": percentValue
      }

      , { header: header })
      .then(function (response) {

        getAgency();
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          seterrMsg(msg);
          setShowError(true);
        } else {
          setShowPercenChange(false);
        }

        setIsLoading(false)

      })
      .catch(function (err) {
        setIsLoading(false)
        setShowPercenChange(false);
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          seterrMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          setShowError(true);
        }
        //setShowError(true);
      });
  }

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }


  const getAgency = async () => {
    const response = await axios.get(bUrl + "/agencies/Agency-by-Id?id=" + id).catch((err) => {
      console.log(err);
      setIsLoading(false)

    });
    if (response) {

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      } else {
        setAgency(response.data.body);
      }

      setIsLoading(false);

      if (response.status == 401) {
        navigate('/backoffice/login');
      }
    }
  }


  const downloadQRCode = () => {
    htmlToImage.toPng(qrCodeRef.current).then(function (dataUrl) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "qr-code.png";
      link.click();
    })
      .catch(function (error) {
        console.error("Error generating QR code:", error);
      });
  };
  useEffect(() => {
    if (sessionStorage.getItem("aname") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getAgency();
  }, []);
  return (
    <div>
      <Sidebar />
      <section className="home ">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
              <div><p className='fw-bold'>{Agency !== null ? Agency.profile == 'CUSTOMER' ? 'Clients' : 'Agency' : ""} &gt; Détails</p></div>
              <div><Topbar /></div>
            </div>
            {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
              <div className="table-content mt-3 p-3">
                <div className='row d-flex justify-content-center'>
                  {/* <div className='col-md-3'><input type="file" multiple ref={inputFile} hidden onChange={(e)=>handleFileChange(e)}/>
            <img src={Agency.name} alt='img' className='w-100 im-upload' /> 
            </div> */}
                  <div className='col-md-3 bg-primary'>
                  </div>
                  {/* <button className='btn' onClick={} >Changer</button> */}
                  {Agency ?
                    <div className='col-md-6'>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Name:</div>
                        <div className='col-8 fw-bold'>{Agency.name}</div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Email:</div>
                        <div className='col-8 fw-bold'>{Agency.email}</div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Numéro Téléphone:</div>
                        <div className='col-8 fw-bold'>{Agency.phone}
                        </div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Code:</div>
                        <div className='col-8 fw-bold'>{Agency.code}
                        </div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Date Modification:</div>
                        <div className='col-8 fw-bold'>{formatDate(Agency.updatedDate)}
                        </div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Date Création:</div>
                        <div className='col-8 fw-bold'>{formatDate(Agency.createdDate)}
                        </div>
                      </div>

                      <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Pourcentage d'achat:</div>
                        <div className='col-8 fw-bold'>
                          {Agency.percentagePurchase + " % "}
                          <a className='clickable btn-link' onClick={() => setShowPercenChange(true)}>Changer</a>
                        </div>
                      </div>

                      {Agency.accounting !== null ?
                        <>
                          <div className='row mb-2 row-details p-2'>
                            <div className='col-4'>Solde:</div>
                            <div className='col-8 fw-bold'>{Agency.accounting.balance} {Agency.accounting.currency}</div>
                          </div>
                        </>
                        : ""}


                      {Agency.staff !== null ?
                        <>
                          <div className='row mb-2 row-details p-2'>
                            <div className='col-4'>Modifié Par:</div>
                            <div className='col-8 fw-bold'>{Agency.staff.firstName + ' ' + Agency.staff.middleName + ' ' + Agency.staff.lastName + " | " + Agency.staff.login}</div>
                          </div>
                        </>
                        : ""}

                    </div>
                    : <></>}
                  <div className='qr-containe col-md-3' ref={qrCodeRef} >
                    {/* <QRCode
              size={256}
              id="123456"
              style={{ height: "auto", maxWidth: "100%", width: "90%" }}
              value={Agency.code}
              fgColor="#005f99"
              bgColor="#fff"
              viewBox={`0 0 256 256`}/>
              <div onClick={downloadQRCode} style={{textAlign:'center',cursor:'pointer'}}>Download QR Code</div> */}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
      <Modal show={showPercenChange} onHide={handleCloseUpdate} className="sm">
        <Modal.Header closeButton>
          <Modal.Title>Modifier le Pourcentage d'achat</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-6'>
              <input type='number' min={0} max={100} value={percent}
                onChange={(e) => setPercent(e.target.value)} className="form-control form-control-sm" />

            </div>
            <div className='col-md-6' style={{ fontWeight: 'bold', fontSize: '1.5em' }}>%</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={upadatePercent}>
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

